import './App.css';
import Home from './components/Home';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';

function App() {
  return (
    <>
    <Home/>
    <About/>
    <Portfolio/>
    <Contact/>
    </>
  );
}

export default App;
